<template>
  <v-app :style="{background: $vuetify.theme.themes[theme].background}">
    <v-img src="@/assets/background4.jpg" contain position="top">
      <v-main>
        <Header></Header>
        <v-container class="pt-15">
          <router-view/>
        </v-container>
        <Footer></Footer>
      </v-main>
    </v-img>
  </v-app>
</template>

<style lang="scss">
  $font-family: 'Exo';

  body {
    font-family: $font-family, sans-serif !important;
  }

  .v-application {
    font-family: $font-family, sans-serif !important;
    .title, .headline, .display-2 {
      font-family: $font-family, sans-serif !important;
    }
  }
</style>

<script>

    import Header from "@/components/Header"
    import Footer from "@/components/Footer"

    export default {
        name: 'App',

        components: {
            Footer,
            Header
        },
        computed: {
            theme() {
                return (this.$vuetify.theme.dark) ? 'dark' : 'light'
            }
        },
        data: () => ({}),
    };
</script>
